/* eslint-disable no-redeclare */
import { z } from 'zod';

export const Email = z.string().email({
  message: 'This field is required. Please enter a valid email address.',
});

export type Email = z.infer<typeof Email>;
